import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { Button, Typography } from "@shared/ui";
import { Space } from "antd";
import {
  ClipboardList,
  Compass,
  Plus,
  ShoppingBag,
  Star,
  Users,
} from "lucide-react";
import styles from "./CampaignBriefEmptyState.module.scss";
import type { StatusFilter } from "./CampaignBriefFilters";
import { CampaignBriefStage } from "../lib/campaignBriefStage";

interface CampaignBriefEmptyStateProps {
  activeStatusFilter: StatusFilter;
  onStatusFilterChange: (filter: StatusFilter) => void;
  onAddCreator: () => void;
  shortlistedCount?: number;
  purchasedCount?: number;
}

const { Title, Text } = Typography;

export function CampaignBriefEmptyState({
  activeStatusFilter,
  onStatusFilterChange,
  onAddCreator,
  shortlistedCount = 0,
  purchasedCount = 0,
}: CampaignBriefEmptyStateProps) {
  const { brief } = useBriefStore();
  const hasMovedPastReviewing = shortlistedCount + purchasedCount > 0;

  return (
    <div className={styles.emptyState}>
      {activeStatusFilter === CampaignBriefStage.Reviewing &&
        (hasMovedPastReviewing ? (
          <>
            <div className={styles.iconWrapper}>
              <Users size={32} className={styles.icon} />
            </div>
            <Title level={3} className={styles.title}>
              No creators in reviewing
            </Title>
            <Text className={styles.description}>
              Everyone in this campaign has been shortlisted or purchased. Open
              Shortlisted to proceed with purchase, or Purchased to review
              committed creators.
            </Text>
            <Space className={styles.actions} size={12}>
              <Button
                onClick={() =>
                  onStatusFilterChange(CampaignBriefStage.Shortlisted)
                }
                className={styles.shortlistButton}
                icon={<Star size={16} />}
              >
                View shortlisted
              </Button>
              <Button
                onClick={onAddCreator}
                className={styles.secondaryButton}
                icon={<Plus size={16} />}
              >
                Add Creator
              </Button>
            </Space>
          </>
        ) : (
          <>
            <div className={styles.iconWrapper}>
              <Users size={32} className={styles.icon} />
            </div>
            <Title level={3} className={styles.title}>
              Start your campaign brief
            </Title>
            <Text className={styles.description}>
              Suggested creators will appear here. You can also proactively find
              and add creators to this campaign from the Discovery page.
            </Text>
            <Space className={styles.actions} size={12}>
              <Button
                onClick={onAddCreator}
                className={styles.secondaryButton}
                icon={<Plus size={16} />}
              >
                Add Creator
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  try {
                    // const campaignKey = `campaign_${Date.now()}_${Math.random()
                    //   .toString(36)
                    //   .slice(2, 10)}`;
                    // sessionStorage.setItem(campaignKey, JSON.stringify(brief));
                    // window.open(
                    //   `${ROUTES.DiscoverySearch}?campaignKey=${encodeURIComponent(
                    //     campaignKey
                    //   )}`,
                    //   "_blank"
                    // );
                  } catch (err) {
                    console.error(
                      "Failed to open Global Discovery with campaign:",
                      err
                    );
                  }
                }}
                className={styles.primaryButton}
                icon={<Compass size={16} />}
              >
                Go to Discovery
              </Button>
            </Space>
          </>
        ))}
      {activeStatusFilter === CampaignBriefStage.Shortlisted && (
        <>
          <div className={`${styles.iconWrapper} ${styles.shortlistIcon}`}>
            <Star size={32} className={styles.starIcon} />
          </div>
          <Title level={3} className={styles.title}>
            No shortlisted creators yet
          </Title>
          <Text className={styles.description}>
            Shortlist creators from Reviewing, then purchase from this view when
            commercials are ready.
          </Text>
          <Space className={styles.actions} size={12}>
            <Button
              onClick={() => onStatusFilterChange(CampaignBriefStage.Reviewing)}
              className={styles.secondaryButton}
              icon={<ClipboardList size={16} />}
            >
              View reviewing
            </Button>
          </Space>
        </>
      )}
      {activeStatusFilter === CampaignBriefStage.Purchased && (
        <>
          <div className={styles.iconWrapper}>
            <ShoppingBag size={32} className={styles.icon} />
          </div>
          <Title level={3} className={styles.title}>
            No creators purchased yet
          </Title>
          <Text className={styles.description}>
            Once you finalize commercials and click &quot;Purchase&quot;,
            creators will move here and to the execution phase.
          </Text>
          <Space className={styles.actions} size={12}>
            <Button
              type="primary"
              onClick={() =>
                onStatusFilterChange(CampaignBriefStage.Shortlisted)
              }
              className={styles.primaryButton}
            >
              View Shortlisted
            </Button>
          </Space>
        </>
      )}
    </div>
  );
}
